import { colors } from 'Constants/Colors';
import { makeStyles } from '@mui/styles';
import '@fontsource/metropolis';

const textFieldStyles = makeStyles(theme => ({
  disabled: {
    '& .MuiInputLabel-root': {
      fontFamily: 'var(--app-font)',
    },
    '& .MuiOutlinedInput-root': {
      background: colors.GRAY_TEXT_FIELD,
      borderRadius: '1rem',

      '& .MuiOutlinedInput-input': {
        WebkitTextFillColor: 'black',
        fontFamily: 'var(--app-font)',
        fontWeight: 'bold',
      },
    },
  },
  enabled: {
    '& .MuiInputLabel-root': {
      fontFamily: 'var(--app-font)',
    },
    '& .MuiOutlinedInput-root': {
      background: 'white',
      borderRadius: '1rem',
      '&.Mui-focused fieldset': {
        borderColor: colors.GREEN_LEAF,
      },
      '& .MuiOutlinedInput-input': {
        WebkitTextFillColor: 'black',
        fontFamily: 'var(--app-font)',
      },
    },
  },
  input: {
    color: 'red',
  },
}));

export default {
  textFieldStyles,
  textField: {
    width: '50%',
  },
};
